import { App as CapApp, URLOpenListenerEvent } from '@capacitor/app';
import { IonicVue } from '@ionic/vue';
import '@ionic/vue/css/core.css';
import '@ionic/vue/css/display.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/typography.css';
import { createApp } from 'vue';
import 'instantsearch.css/themes/reset.css';
import App from './App.vue';
import './css/global.css';
import { apolloClient, apolloProvider } from './graphql/client';
import './registerServiceWorker';
import router from './router';
import store from './store';
import './theme/variables.css';
import InstantSearch from 'vue-instantsearch/vue3/es';
import { Browser } from '@capacitor/browser';
import { processSharedAudioFile } from './services/shared-audio-file-service';
import { LDPlugin } from 'launchdarkly-vue-client-sdk';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import { DefaultApolloClient } from '@vue/apollo-composable';
import { createPinia } from 'pinia';
import RenewedSharePlaylistModal from '@/components/share/RenewedSharePlaylistModal.vue';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

Bugsnag.start({
  apiKey: process.env.VUE_APP_BUGSNAG_KEY || '',
  plugins: [new BugsnagPluginVue()],
  enabledReleaseStages: ['production', 'staging'],
});

const bugsnagVue = Bugsnag.getPlugin('vue');

const pinia = createPinia();

const app = createApp(App)
  .use(store)
  .use(pinia)
  .use(IonicVue, { mode: 'ios' })
  .provide(DefaultApolloClient, apolloClient)
  .use(InstantSearch)
  .use(apolloProvider)
  .use(LDPlugin, {
    clientSideID: process.env.VUE_APP_LD_KEY,
    deferInitialization: true,
  });
app
  .component('RenewedSharePlaylistModal', RenewedSharePlaylistModal)
  .use(router);

if (bugsnagVue) {
  app.use(bugsnagVue);
}

CapApp.addListener('appUrlOpen', async function (event: URLOpenListenerEvent) {
  const slug = event.url.split('.app').pop();
  console.log('in cap listener');
  console.log(event);

  if (slug) {
    const splitter = slug.split('/');
    const route = splitter[splitter.length - 1];
    console.log('in cap listener', route);
    if (route.includes('login')) {
      const q = route.split('?');
      const code = q[1].split('=');
      if (code) {
        store.dispatch('bootApp', code[1]);
        Browser.close();
      }
    } else {
      await router.push({
        path: event.url.replace(process.env.VUE_APP_FRONTEND_DOMAIN || '', ''),
      });
    }
  }

  if (event.url.includes('file://')) {
    processSharedAudioFile(event.url);
  }
});

router.isReady().then(async () => {
  app.mount('#app');
});
